import type { ActivitySessionPricingType } from "@/db/schema/activity-session";
import type { ActivitySessionSplitPricing } from "@/db/schema/activity-session-split";
import {
  type SplitPricingShape,
  worstCaseShareMinor,
} from "@/lib/activity-sessions/split";

export type SessionCreateMoneyInput = {
  collectMoney: boolean;
  splitPricing: ActivitySessionSplitPricing;
  splitAmountMinor: number;
  minParticipants: number;
  organizerPlaying: boolean;
};

/**
 * The split ledger is authoritative. The session row also stores a stable
 * display price, so divided totals publish the worst-case share there without
 * persisting the moving live share.
 */
export const deriveActivitySessionCreatePricing = (
  values: SessionCreateMoneyInput,
): {
  pricingType: ActivitySessionPricingType;
  pricePerPersonAmountMinor: number;
} => {
  if (!values.collectMoney) {
    return {
      pricingType: "free",
      pricePerPersonAmountMinor: 0,
    };
  }

  const shape: SplitPricingShape =
    values.splitPricing === "divide_total"
      ? {
          pricing: "divide_total",
          totalAmountMinor: values.splitAmountMinor,
        }
      : {
          pricing: "fixed_per_person",
          perPersonAmountMinor: values.splitAmountMinor,
        };

  return {
    pricingType: "paid",
    pricePerPersonAmountMinor: worstCaseShareMinor({
      shape,
      minParticipants: values.minParticipants,
      organizerPlaying: values.organizerPlaying,
    }),
  };
};
